// src/redux/slices/library/reservation.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReservationType } from "../../../types/Library";

const initialState: ReservationType = {
    reservationDate: "",
    idBook: "",
    idUser: "",
    startDate: "",
    endDate: ""
};

const reservationSlice = createSlice({
    name: "reservation",
    initialState,
    reducers: {
        setReservationData: (state, action: PayloadAction<ReservationType>) => ({
            ...state,
            ...action.payload,
        }),
        resetReservationData: () => initialState,
    },
});

export const { setReservationData, resetReservationData } = reservationSlice.actions;
export default reservationSlice.reducer;
